module.exports = __webpack_public_path__ + "media/images/calendar-7eedc840a28ecb2894f06c91f8ccfb14.svg";